module.exports = __webpack_public_path__ + "da51fbf8cda0f0b31ca9e3c1382ade63.png";